import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import {
  Spin,
  Select,
  Row,
  Col,
  Table,
} from 'antd';
import { custServiceBillCalFindCalListByRequest, custServiceBillCalFindCalType } from '@/services/fmsServices';
const Option = Select.Option;
interface reciptTypeListType {
  priKey: string;
  name: string;
}
export const CollectionCountHtml = Recat.forwardRef((props: any) => {
  const { orderId } = props;
  const [loading, setLoading] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [dataSource, setDataSource] = useState([] as any[]);
  const [reciptTypeList, setReciptTypeList] = useState([] as reciptTypeListType[]);
  const columns = [
    {
      title: '类型',
      key: 'transactionCalName',
      dataIndex: 'transactionCalName',
      width: '200px',
      render: (text: any, record: any) => {
        let obj = {
          children: text,
          props: { rowSpan: record.handleRowSpan },
        };
        return obj;
      },
    },
    { title: '项目主内容', key: 'name', dataIndex: 'name', width: '200px' },
    { title: '金额', key: 'calcAmount', dataIndex: 'calcAmount', width: '200px' },
    { title: '取数说明', key: 'description', dataIndex: 'description', width: '200px' },
  ];
  useEffect(() => {
    initFn();
  }, []);
  const initFn = () => {
    getType();
  };
  const getType = () => {
    setSpinning(true);
    custServiceBillCalFindCalType({}).then((res: any) => {
      setReciptTypeList(res);
      setSpinning(false);
    }).catch((err: any) => {
      setSpinning(false);
    });;
  }
  // 优化后的代码
  const calculateRowSpans = (list: any[]) => {
    let counter = 0,
      num = 0,
      firstFlag = false,
      subScript = 0;
    for (let i = 0; i < list.length; i++) {
      list[i].key = list[i].id;
      /**
       *  id重复的元素的个数赋值给首次出现元素的handleRowSpan
       *  非首次出现的元素handleRowSpan的值改为0
       *  没有重复的元素handleRowSpan的值为1
       * */
      if (list[i + 1]) {
        if (list[i].transactionCalName === list[i + 1].transactionCalName) {
          if (!firstFlag) {
            subScript = i;
            firstFlag = true;
          }
          counter++;
          list[i].handleRowSpan = 0;
        } else {
          if (list[i - 1]) {
            if (list[i].transactionCalName === list[i - 1].transactionCalName) {
              list[i].handleRowSpan = 0;
              list[subScript].handleRowSpan = counter + 1;
            } else {
              list[i].handleRowSpan = 1;
            }
          }
          firstFlag = false;
          subScript = 0;
          counter = 0;
        }
      } else if (list[i - 1]) {
        if (list[i].transactionCalName === list[i - 1].transactionCalName) {
          list[i].handleRowSpan = 0;
          list[subScript].handleRowSpan = counter + 1;
        } else {
          list[i].handleRowSpan = 1;
        }
      } else {
        list[i].handleRowSpan = 1;
      }
    }

    return list;
  };
  const onChangeReciptType = (e: any) => {
    setLoading(true);
    custServiceBillCalFindCalListByRequest({
      orderId: orderId,
      calType: e,
    }).then((res: any) => {
      setLoading(false);
      setDataSource(calculateRowSpans(res?.calResponseList || []));
    }).catch((err: any) => {
      setLoading(false);
    });
  };
  const span = { span: 24 };
  return (
    <Spin spinning={spinning}>
      <Row style={{ marginBottom: '20px' }}>
        <Col {...span}>
          款项：
          <Select
            showSearch
            placeholder="请先选择款项"
            allowClear={false}
            style={{ width: '150px' }}
            onChange={(v) => onChangeReciptType(v)}
            filterOption={(input, option) => option?.props?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          >
            {reciptTypeList.map((item: any, index) => {
              return (
                <Option key={index} value={item?.parentKey}>
                  {item.name}
                </Option>
              );
            })}
          </Select>
        </Col>
      </Row>
      <Table
        rowKey="id"
        className="tableList"
        columns={columns}
        size="small"
        dataSource={dataSource}
        loading={loading}
        pagination={false}
      />
    </Spin>
  );
})
